<form #myform="ngForm" class="form-group" style="height: 100%">
  <!--Form Header-->
  <div class="formpage-header">
    <h3 class="page-titre"><mat-icon>business_center</mat-icon> {{ titre }}</h3>
  </div>

  <!--Form Body-->
  <div class="formpage-body" *ngIf="currentItem">
    <div class="form-col">
      <mat-form-field appearance="outline">
        <mat-label>Code problème</mat-label>
        <input matInput [(ngModel)]="currentItem.ProblemCode" name="ProblemCode" class="form-control" required />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Description</mat-label>
        <input matInput [(ngModel)]="currentItem.ProblemDescription" name="ProblemDescription" />
      </mat-form-field>

      <section appearance="outline">
        <mat-label></mat-label>
        <mat-checkbox name="IsScan1Enabled" [(ngModel)]="currentItem.IsScan1Enabled">Actif pour le scan1 (réception)</mat-checkbox>
      </section>

      <section appearance="outline">
        <mat-label></mat-label>
        <mat-checkbox name="IsScan2EmballeurEnabled" [(ngModel)]="currentItem.IsScan2EmballeurEnabled">Actif pour le scan2 (emballeur)</mat-checkbox>
      </section>

      <mat-form-field appearance="outline">
        <mat-label>Ordre d'affichage [numérique]></mat-label>
        <input matInput [(ngModel)]="currentItem.DisplayIndex" type="number" name="DisplayIndex" />
      </mat-form-field>
    </div>
  </div>

  <!--Form Footer-->
  <div class="formpage-footer">
    <button type="button" matInput mat-stroked-button (click)="detruire()" [disabled]="!currentItem?.id" style="margin: 0px 2px 2px 2px">
      <mat-icon>delete</mat-icon>Supprimer
    </button>

    <div style="float: right">
      <button type="submit" matInput mat-flat-button (click)="OnSauvegardeClick()" *ngIf="!myform.pristine" color="primary" style="margin: 0px 2px 2px 2px">
        <mat-icon>check</mat-icon>Sauvegarder
      </button>
      <button type="submit" matInput mat-stroked-button (click)="annuler()" *ngIf="myform.pristine" style="margin: 0px 2px 2px 2px">Fermer</button>
      <button type="button" matInput mat-stroked-button (click)="annuler()" *ngIf="!myform.pristine" style="margin: 0px 2px 2px 2px">Ignorer</button>
    </div>
  </div>
</form>
